/**
 * List helpers shared by config panels whose entries each become one input
 * socket keyed by `key` (Browser Use Agent data inputs, Match Customer With
 * Evidence entries). The key is the socket's identity, so it is minted once
 * and never edited; the label is free text.
 */
export interface KeyedInputListEntry {
  key: string;
  label?: string;
}

/** `base` for the first entry, then the first unused `base_1`, `base_2`, … */
export function nextInputKey(
  existing: readonly KeyedInputListEntry[],
  base: string,
): string {
  if (existing.length === 0) return base;
  const takenKeys = new Set(existing.map((entry) => entry.key));
  let index = 1;
  while (takenKeys.has(`${base}_${index}`)) index += 1;
  return `${base}_${index}`;
}

/** Set (or, when blank, clear) one entry's label. */
export function withUpdatedLabel<Entry extends KeyedInputListEntry>(
  entries: readonly Entry[],
  targetIndex: number,
  label: string,
): Entry[] {
  return entries.map((entry, index) =>
    index === targetIndex
      ? { ...entry, label: label.length > 0 ? label : undefined }
      : entry,
  );
}
